import { api } from './client.ts';

export interface Plan {
  code: string;
  displayName: string;
  kind: 'OneTime' | 'Subscription';
  creditsGranted: number;
  priceEur: number;
  description: string;
}

export interface BillingSummary {
  creditBalance: number;
  hasStripeCustomer: boolean;
  recentTransactions: Array<{
    id: string;
    kind: string;
    delta: number;
    balanceAfter: number;
    reason: string;
    createdAt: string;
  }>;
}

export interface CheckoutSessionStatus {
  sessionId: string;
  mode: string;
  paymentStatus: string;
  isPaid: boolean;
  creditsGranted: boolean;
  creditsAmount: number;
  planCode: string | null;
}

export const billingApi = {
  async plans(): Promise<Plan[]> {
    return api<Plan[]>('/api/billing/plans');
  },

  async summary(): Promise<BillingSummary> {
    return api<BillingSummary>('/api/billing/summary');
  },

  async checkout(planCode: string, gclid?: string | null): Promise<{ sessionId: string; url: string }> {
    // Forward the Google Ads click id captured at landing so the server can persist it on the
    // Stripe session metadata for offline conversion attribution. Optional + best-effort.
    return api<{ sessionId: string; url: string }>('/api/billing/checkout', {
      method: 'POST',
      body: { planCode, gclid: gclid ?? undefined },
    });
  },

  /** Creates a Stripe Customer Portal session and returns the URL. SPA does top-level nav. */
  async portal(): Promise<{ url: string }> {
    return api<{ url: string }>('/api/billing/portal', { method: 'POST' });
  },

  /** Verifies a checkout session's payment status. Used by BillingSuccessPage. */
  async retrieveSession(sessionId: string): Promise<CheckoutSessionStatus> {
    return api<CheckoutSessionStatus>(`/api/billing/session/${encodeURIComponent(sessionId)}`);
  },
};
